
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { VezgoConnectionStatus } from './VezgoConnectionStatus';
import { VezgoConnectForm } from './VezgoConnectForm';
import { useVezgoConnectActions } from './useVezgoConnectActions';
import { InvestmentErrorBoundary } from '@/components/investments/InvestmentErrorBoundary';
import { useVezgoConnectState } from './useVezgoConnectState';
import { VezgoConnectFlow } from './VezgoConnectFlow';

export function VezgoConnectPage() {
  const { 
    isConnected,
    connection,
    error,
    processingState,
    setProcessingState
  } = useVezgoConnectState();

  // Now get testToken
  const {
    handleConnect,
    handleDisconnect,
    handleRefresh,
    testToken // Pull in testToken and pass to form
  } = useVezgoConnectActions();

  const navigate = useNavigate();

  return (
    <InvestmentErrorBoundary onReset={() => navigate('/investments/connect', { replace: true })}>
      <div className="w-full max-w-md mr-auto py-8">
        <Card>
          <CardHeader>
            <CardTitle>Connect Cryptocurrency Provider</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <VezgoConnectionStatus />
            <VezgoConnectForm 
              onConnect={handleConnect}
              onRefresh={handleRefresh}
              onDisconnect={handleDisconnect}
              isConnected={isConnected}
              provider={connection?.provider}
              testToken={testToken} // Pass debugging helper
            />
          </CardContent>
        </Card>
      </div>
      <VezgoConnectFlow />
    </InvestmentErrorBoundary>
  );
}
